import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  useTheme,
  alpha,
} from "@mui/material";
import ScrollToTop from "./ScrollToTop";

import AboutUs from "../components/About/AboutUs";
import CoreValues from "../components/About/CoreValues";
import CTASection from "../components/Layout/CTASection";
import SEO from "../components/Layout/SEO";

const AboutPage = () => {
  const theme = useTheme();

  return (
    <Box>
      <SEO
        title="About Us"
        description="Learn about ProtoDiag Solutions - a telecom technology company based in Noida, India, focused on developing next-generation communication infrastructure. Meet our team and discover our mission."
        keywords="ProtoDiag Solutions about, telecom company Noida, communication infrastructure, telecom technology company India, ProtoDiag team"
        url="https://www.protodiag.com/about"
      />
      <ScrollToTop />

      <AboutUs />
      <CoreValues />

      {/* Global Presence Section */}
      <Box
        sx={{
          py: 10,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 2,
              }}
            >
              Our Global Presence
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                maxWidth: 700,
                mx: "auto",
                fontWeight: 400,
              }}
            >
              Headquartered in Noida, India with a growing international reach
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              height: { xs: 300, md: 500 },
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: theme.shadows[4],
              position: "relative",
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              mb: 4,
            }}
          >
            {/* This would be replaced with an actual map component or image */}
            <Box
              component="img"
              src="/assets/images/GlobalImage.jpg"
              alt="ProtoDiag Solutions Global Presence"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  textAlign: "center",
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                }}
              >
                <Typography
                  variant="h4"
                  component="p"
                  color="primary.main"
                  fontWeight={700}
                >
                  Headquarters
                </Typography>
                <Typography variant="body1">
                  1st floor, A-5, Grovy Optiva, Block A, Sector 68, Noida, Basi
                  Bahuddin Nagar, Uttar Pradesh 201316
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  textAlign: "center",
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                }}
              >
                <Typography
                  variant="h4"
                  component="p"
                  color="primary.main"
                  fontWeight={700}
                >
                  Contact
                </Typography>
                <Typography variant="body1">
                  Email: info@protodiag.com
                  <br />
                  Phone: +91-9899817807 / +91-9910274500
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <CTASection
        title="Let's Build the Future of Communication Together"
        description="Join us in revolutionizing telecom infrastructure. Partner with ProtoDiag Solutions for innovative communication solutions."
        primaryButtonText="Get in Touch"
        primaryButtonLink="/contact"
        secondaryButtonText="View Our Solutions"
        secondaryButtonLink="/products"
        variant="secondary"
      />
    </Box>
  );
};

export default AboutPage;
